export const OrderStatus = Object.freeze({
    canceled: Symbol('canceled'),
    new: Symbol('new'),
    processing: Symbol('processing'),
    completed: Symbol('completed'),
    pendingApproval: Symbol('pendingApproval'),
    priceProposal: Symbol('priceProposal'),
    priceRejected: Symbol('priceRejected'),
    priceAccepted: Symbol('priceAccepted'),
    pendingPartnerAccept: Symbol('pendingPartnerAccept'),
    pendingPartnerPricing: Symbol('pendingPartnerPricing'),
    partnerPriced: Symbol('partnerPriced'),
    partnerAccepted: Symbol('partnerAccepted'),
    partnerRejected: Symbol('partnerRejected'),
});

export function getStatusText(status) {
    return {
        [OrderStatus.new]: 'Nowe',
        [OrderStatus.pendingApproval]: 'Akceptacja regulaminu',
        [OrderStatus.processing]: 'Przetwarzanie',
        [OrderStatus.priceProposal]: 'Wysłana propozycja ceny',
        [OrderStatus.priceAccepted]: 'Propozycja ceny zaakceptowana',
        [OrderStatus.priceRejected]: 'Propozycja ceny odrzucona',
        [OrderStatus.completed]: 'Zakończone',
        [OrderStatus.canceled]: 'Anulowane',
        [OrderStatus.pendingPartnerAccept]: 'Oczekuje na akceptację partnera',
        [OrderStatus.pendingPartnerPricing]: 'Oczekuje na wycenę partnera',
        [OrderStatus.partnerPriced]: 'Wycenione przez partnera',
        [OrderStatus.partnerAccepted]: 'Zaakceptowane przez partnera',
        [OrderStatus.partnerRejected]: 'Odrzucone przez partnera',
    }[OrderStatus[status]];
}
